import * as React from 'react'
import { Column } from '../typings'
import { ReducerProps } from '../reducer'
import { sortListItemStyles as useStyles } from './styles'

import Card from '@mui/material/Card'
import IconButton from '@mui/material/IconButton'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'

interface Props extends ReducerProps {
  column: Column
}

export const SortListItem: React.FC<Props> = (props) => {
  const {
    column: { field, label, disabled },
    dispatch,
  } = props

  const onClick = React.useCallback(() => {
    dispatch({ type: 'toggle', payload: { field, value: false } })
  }, [dispatch, field])

  return (
    <Card sx={{ ...useStyles.root }}>
      <Box sx={{ ...useStyles.icon }}>
        <DragIndicatorIcon sx={{ cursor: 'grab' }} fontSize="small" />
      </Box>
      {label}
      {!disabled && (
        <IconButton
          onClick={onClick}
          sx={{ ...useStyles.button }}
          size="small"
          data-test-id={`sortListItemRemoveBtn-${field}`}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Card>
  )
}
